import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {PropertyInactivation} from "../../models/property-inactivation.model";

@Injectable({
  providedIn: 'root'
})
export class InactivatePropertyService {
  private baseUrl = `${environment.apiUrl}/accountProperty`;
  constructor(private http: HttpClient) { }

  inactivateProperty(data: PropertyInactivation) {
    return this.http.put<void>(`${this.baseUrl}/inactivate`, data);
  }

  getLastInactivation(propertyId: number) {
    return this.http.get<PropertyInactivation>(`${this.baseUrl}/${propertyId}/lastInactivation`);
  }


}
